import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ProjectSetupFRequest } from '@app/models/project-setup.models';

export interface SectionFFormData {
  mainRights: string | null;
  restrictions: string | null;
  descriptionOfRestriction: string | null;
  exitOptions: string | null;
  equityInstruments: string | null;
}

export interface SectionFFormGroup {
  mainRights: FormControl<string | null>;
  restrictions: FormControl<string | null>;
  descriptionOfRestriction: FormControl<string | null>;
  exitOptions: FormControl<string | null>;
  equityInstruments: FormControl<string | null>;
}

export function getSectionFFormGroup(
  fb: FormBuilder
): FormGroup<SectionFFormGroup> {
  return fb.nonNullable.group({
    mainRights: fb.nonNullable.control<string | null>(null),
    restrictions: fb.nonNullable.control<string | null>(null),
    descriptionOfRestriction: fb.nonNullable.control<string | null>(null),
    exitOptions: fb.nonNullable.control<string | null>(null),
    equityInstruments: fb.nonNullable.control<string | null>(null),
  });
}

export function getSectionFUpdateData(
  formGroup: FormGroup<SectionFFormGroup>
): ProjectSetupFRequest {
  return {
    keyRightsForTransferableSecuritiesOrCrowdfundingAssets:
      formGroup.controls.mainRights.value!,
    keyRightsForTransferableSecuritiesOrCrowdfundingAssetsDenial:
      formGroup.controls.restrictions.value!,
    keyRightsForTransferableSecuritiesOrCrowdfundingAssetsRestrictions:
      formGroup.controls.descriptionOfRestriction.value!,
    exitOptionsForInvestors: formGroup.controls.exitOptions.value!,
    capitalAndVotingRightsDistributionBeforeAndAfterOffer:
      formGroup.controls.equityInstruments.value!,
  };
}

export function patchSectionFFormWithProjectSetupFRequest(
  formGroup: FormGroup<SectionFFormGroup>,
  response: ProjectSetupFRequest
): FormGroup<SectionFFormGroup> {
  formGroup.setValue({
    mainRights: response.keyRightsForTransferableSecuritiesOrCrowdfundingAssets,
    restrictions:
      response.keyRightsForTransferableSecuritiesOrCrowdfundingAssetsDenial,
    descriptionOfRestriction:
      response.keyRightsForTransferableSecuritiesOrCrowdfundingAssetsRestrictions,
    exitOptions: response.exitOptionsForInvestors,
    equityInstruments:
      response.capitalAndVotingRightsDistributionBeforeAndAfterOffer,
  });
  return formGroup;
}
